document.addEventListener('DOMContentLoaded', function () {

  /* -----------------------------
     SLICK INITIALIZE
  ------------------------------*/
  $('.images-gallery').each(function () {
    $(this).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      speed: 300,
      infinite: true,
      autoplay: false,
      prevArrow: `<button type="button" class="slick-prev">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="40" y="40" width="40" height="40" rx="20" transform="rotate(180 40 40)" fill="#FFFCEE"></rect>
<path d="M22.5 15L17.5 20L22.5 25" stroke="#2B1200" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>
      </button>`,
      nextArrow: `<button type="button" class="slick-next">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="40" height="40" rx="20" fill="#FFFCEE"></rect>
<path d="M17.5 25L22.5 20L17.5 15" stroke="#2B1200" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>
      </button>`
    });
  });

// document.querySelectorAll('.images-gallery').forEach(function(gallery) {

//   gallery.addEventListener('click', function(e) {

//     if (e.target.closest('.slick-prev') || e.target.closest('.slick-next')) {
//       return;
//     }

//     if (!$(gallery).hasClass('slick-initialized')) return;

//     const rect = gallery.getBoundingClientRect();
//     const clickX = e.clientX - rect.left;
//     const galleryWidth = rect.width;

//     if (clickX < galleryWidth / 2) {
//       $(gallery).slick('slickPrev');
//     } else {
//       $(gallery).slick('slickNext');
//     }

//   });

// });
  // Check all galleries on page load for single-image products
    // document.querySelectorAll('.MainProduct_Wrapper').forEach(function(wrapper) {
    //   const gallery = wrapper.querySelector('.images-gallery');
    //     const atcBtn = wrapper.querySelector('.add-to-cart-button');
      
    //   if (!gallery || !atcBtn) return;

    //   const visibleSlides = gallery.querySelectorAll('.slick-slide:not(.slick-cloned)').length;

    //   if (visibleSlides <= 1) {
    //     wrapper.classList.add('single-image-active-outer');
    //   } else {
    //     wrapper.classList.remove('single-image-active-outer');
    //   }
    //   gallery.addEventListener('click', function(e) {
    //     // Only trigger if single-image-active class is present
    //     if (!wrapper.classList.contains('single-image-active-outer')) return;

    //     // Ignore arrow clicks
    //     if (e.target.closest('.slick-prev') || e.target.closest('.slick-next')) return;

    //     // Trigger Add to Cart
    //     atcBtn.click();
    // });
    // });

  /* VARIANT LOGIC*/
 document.querySelectorAll('.Allvariants').forEach(function(wrapper) {
  const varientAdd = wrapper.closest('.varient-add');
  if (!varientAdd) return;

  const productCard = varientAdd.previousElementSibling;
  if (!productCard) return;

  const productMain = productCard.querySelector('[data-variants]');
  if (!productMain) return;

  const variantsRaw = productMain.getAttribute('data-variants');
  const variants = JSON.parse(
    variantsRaw.replace(/&quot;/g, '"').replace(/&#39;/g, "'")
  );

  wrapper.querySelectorAll('select.variants-dropdown').forEach(function(select) {

    // Show all images on select focus (when user clicks to open the dropdown)
    // select.addEventListener('focus', function() {
    //   const optionName = select.getAttribute('name');
    //   if (optionName && optionName.toLowerCase().includes('color')) {
    //     const gallery = productCard.querySelector('.images-gallery');
    //     if (gallery && $(gallery).hasClass('slick-initialized')) {
    //       $(gallery).slick('slickUnfilter');  // show all images
    //       //$(gallery).slick('slickGoTo', 0);
    //     }
    //   }
    // });

    // Filter images on select change (when user picks a color)
    select.addEventListener('change', function() {

      // Existing variant selection logic you already have here
      // (price update, variant id update, inventory check etc.)
      const allSelects = wrapper.querySelectorAll('select.variants-dropdown');
      let selectedValues = [];

      allSelects.forEach(function(sel) {
        if (sel.value && sel.value !== '') {
          selectedValues.push(sel.value);
        }
      });

      if (selectedValues.length === 0) return;

      const matchedVariant = variants.find(function(variant) {
        return selectedValues.every(function(val, index) {
          return variant.options[index] === val;
        });
      });

      if (!matchedVariant) return;

      const variantInput = varientAdd.querySelector('.PWsvarint_id');
      if (variantInput) {
        variantInput.value = matchedVariant.id;
      }

      const priceEl = productCard.querySelector('.price');
      if (priceEl) {
        const price = (matchedVariant.price / 100).toFixed(2);
        priceEl.textContent = '£' + price;
      }

      const atcBtn = varientAdd.querySelector('.add-to-cart-button');
      const atcText = varientAdd.querySelector('.changeATc');

      if (atcBtn && atcText) {
        const isAvailable = matchedVariant.available;

        if (!isAvailable) {
          atcText.textContent = 'Sold Out';
          atcBtn.disabled = true;
          atcBtn.classList.add('sold-out');
        } else {
          atcText.textContent = 'Add';
          atcBtn.disabled = false;
          atcBtn.classList.remove('sold-out');
        }
      }

      // Now do image filter **only on color select change**
      const optionName = select.getAttribute('name');
      if (optionName && optionName.toLowerCase().includes('color')) {
        const gallery = productCard.querySelector('.images-gallery');
        if (gallery && $(gallery).hasClass('slick-initialized')) {
          const selectedColor = select.value.toLowerCase().trim();

$(gallery).slick('slickUnfilter');

$(gallery).slick('slickFilter', function(index, slide) {
  return $(slide).data('color') === selectedColor;
});

setTimeout(function(){
  $(gallery).slick('slickGoTo', 0, true);
}, 50);
        }
      }

    });
  });

});

});


window.addEventListener("scroll", function() {

    let scroll1 = 250;
    let scroll2 = 700;

    if (window.innerWidth <= 768) {
        scroll1 = 700;
        scroll2 = 1000;
    }

    if (window.scrollY >= scroll1) {
        document.body.classList.add("scroll-active");
    } else {
        document.body.classList.remove("scroll-active");
    }

    if (window.scrollY >= scroll2) {
        document.body.classList.add("section-2-active");
    } else {
        document.body.classList.remove("section-2-active");
    }

});


// window.addEventListener("scroll", function() {
//     if (window.scrollY >= 250) {
//         document.body.classList.add("scroll-active");
//     } else {
//         document.body.classList.remove("scroll-active");
//     }
// });

// window.addEventListener("scroll", function() {
//     if (window.scrollY >= 700) {
//         document.body.classList.add("section-2-active");
//     } else {
//         document.body.classList.remove("section-2-active");
//     }
// });



